import { render } from "./Login.vue?vue&type=template&id=06d3c908&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-06d3c908"

export default script